import React,{useEffect} from 'react'
import { useDispatch, useSelector } from "react-redux";

import { fetchMe} from "../../redux/slice/authSlice";
const Points = () => {
    const dispatch = useDispatch();
    const { personalDetail } = useSelector(({ auth }) => auth);
    useEffect(() => {
      dispatch(fetchMe({})); 
    }, [dispatch]);

  return (
    <span>{personalDetail?.balance?? 0}</span>
  )
}

export default Points
